var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "#ED3241"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_64_9175",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 10,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7949 4.91722C13.0713 5.19908 13.0673 5.652 12.7858 5.92883L6.83102 11.7862L3.21377 8.22814C2.93234 7.95131 2.92826 7.4984 3.20467 7.21653C3.48108 6.93467 3.93331 6.93059 4.21474 7.20742L6.83102 9.78087L11.7849 4.90811C12.0663 4.63128 12.5185 4.63536 12.7949 4.91722Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_64_9175)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.00024,
    y: 3,
    width: 9.99961,
    height: 9.99961,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.91b0217b4a70a8a5797fd75a56970f6f.svg";
export { ForwardRef as ReactComponent };